const getNodeLatLng = (node) => {
    const data = node?.data;
    if (!data) return null;

    let lat;
    let lng;

    if (data.lat != null || data.lng != null) {
        lat = data.lat;
        lng = data.lng;
    } else if (data.latitude != null || data.longitude != null) {
        lat = data.latitude;
        lng = data.longitude;
    } else {
        return null;
    }

    const numLat = Number(lat);
    const numLng = Number(lng);

    if (!Number.isFinite(numLat) || !Number.isFinite(numLng)) return null;
    if (numLat === 0 && numLng === 0) return null;
    if (numLat < -90 || numLat > 90 || numLng < -180 || numLng > 180) return null;

    return {lat: numLat, lng: numLng};
};

export default getNodeLatLng;
